import {XauditModel} from '../xaudit.model';
import {ToothLocationConfigurationModel} from './tooth-location-configuration.model';
import {ToothDescriptionConfigurationModel} from './tooth-description-configuration.model';
import {ToothSurfaceConfigurationModel} from './tooth-surface-configuration.model';
import {ToothCanalConfigurationModel} from '../configuration/tooth-canal-configuration.model';

export class ToothConfigurationModel extends XauditModel {
  ToothId: string;
  Name: string;
  cfgToothLocations: ToothLocationConfigurationModel[];
  cfgToothDescriptions: ToothDescriptionConfigurationModel[];
  enumToothLocationId: string;
  PhysicalVorder: number;
  PhysicalHorderLR: number;
  enumToothGroupTypeId: string;
  cfgToothCanals: ToothCanalConfigurationModel[];
  cfgToothSurfaces: ToothSurfaceConfigurationModel[];

  // For tooth picker
  selectedSurfaceIds: string[] = [];
}
